// @ts-nocheck
import { captureException } from '@sentry/browser';
import React from 'react';

import ErrorFallback from './ErrorFallback';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        captureException(error, { extra: { componentStack: errorInfo?.componentStack } });
    }

    render() {
        const { hasError } = this.state;
        const { children, fallback } = this.props;

        if (hasError) {
            return fallback || <ErrorFallback />;
        }

        return children;
    }
}

export default ErrorBoundary;
